import Helper from './Helper';

class Accordion {
  constructor(config = {}) {
    const {
      accordions,
      pxCorrectionMobile,
      pxCorrectionDesktop,
      mobileBreakpoint
    } = config;
    this.trigger = accordions;
    this.pxCorrectionMobile = pxCorrectionMobile;
    this.pxCorrectionDesktop = pxCorrectionDesktop;
    this.mobileBreakpoint = mobileBreakpoint;

    this.accordions = Array.prototype.slice.call(document.querySelectorAll(accordions));
    this.currentEl = null;

    if (this.accordions && this.accordions.length !== 0) {
      this.bindEvents();

      const url = location.href;
      const id = url.split('#');

      if (!!id[1] && !!document.querySelector(`#${id[1]}`)) {
        let anchor = false;
        let accordionToClick = document.querySelector(`#${id[1]}`);
        const accordionToScroll = document.querySelector('#' + id[1]);

        // exit if ID is not available in DOM
        if (!accordionToScroll) {
          return;
        }

        const headerOffset = document.querySelector('.header').offsetHeight;
        const elementPosition = accordionToScroll.offsetTop;
        const offsetPosition = elementPosition;
        if(!!document.querySelector('.accordion')){
          if (accordionToClick) {
            console.log(accordionToClick);
            const scrollElement = accordionToClick;
            while(!accordionToClick.classList.contains('accordion')){
              anchor = true;
              accordionToClick = accordionToClick.parentElement;
            }
            const accordionHeader = accordionToClick.querySelector('.js-slide-toggler');
            const accordionHeaderHeight = accordionHeader.offsetHeight;
            let pxCorrection = "";
            window.addEventListener('load', () => {
              pxCorrection = this.setPxCorrection();
            });

            window.addEventListener('resize', () => {
              pxCorrection = this.setPxCorrection();
            });

            accordionHeader.click();
            setTimeout(() => {
              if(anchor){
                scrollElement.scrollIntoView({behavior: "smooth"});
              } else{
                window.scrollTo({
                  top: (offsetPosition - pxCorrection),
                  behavior: "smooth"
                });
              }
            }, 1000);
          } else {
            setTimeout(() => {
              window.scrollTo({
                top: (offsetPosition + pxCorrection),
                behavior: "smooth"
              });
            }, 1000);
          }
        }

      }
    }
  }

  bindEvents() {
    this.accordions.forEach(el => {
      el.addEventListener('click', (e) => {
        if (el.classList.contains('active')) {
          Helper.slideClose(el.nextElementSibling);
          el.classList.remove('active');
          el.nextElementSibling.classList.remove('active');
        } else {
          el.classList.add('active');
          Helper.slideOpen(el.nextElementSibling, true);
          el.nextElementSibling.classList.add('active');
        }
      });
    });
  }

  setPxCorrection() {
    if (window.innerWidth >= this.mobileBreakpoint ) {
      return this.pxCorrectionDesktop;
    } else {
      return this.pxCorrectionMobile;
    }
  }
}

export default Accordion;
